import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Glassdoor: React.FC<IconProps> = ({ color, size, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" style={{ ...style }} viewBox="0 0 32 32" data-testid="glassdoor-icon">
    <g fill={color ?? '#fff'} fillRule="evenodd" clipPath="url(#atta)" clipRule="evenodd">
      <path d="M15.783 20.592H27c.082 0 .153-.077.153-.165V9.367c0-2.704-.9-4.903-2.71-6.438-1.67-1.41-4.17-2.263-7.515-2.434a.152.152 0 0 0-.153.153v4.169c0 .082.065.147.142.152 2.934.206 5.162 1.153 5.162 4.445h-6.303c-.082 0-.153.077-.153.171v10.836c0 .088.07.165.153.165l.006.006ZM12.219 9.408H1.006c-.082 0-.152.077-.152.165v10.836c0 .094.07.165.152.165H7.31c0 3.298-2.228 4.245-5.162 4.45a.153.153 0 0 0-.141.153v4.175c0 .088.07.159.153.153 3.345-.17 5.844-1.023 7.508-2.434 1.811-1.535 2.705-3.734 2.71-6.439V9.567c0-.094-.07-.165-.152-.165l-.006.006Z" />
    </g>
    <defs>
      <clipPath id="atta">
        <path fill={color ?? '#fff'} d="M.854.495h26.294v29.01H.854z" />
      </clipPath>
    </defs>
  </svg>
);
export default Glassdoor;
